exports = module.exports = require("../../../../../../.config/yarn/global/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "button[data-v-44895b23]{background-color:var(--brainstorm-accent-fg);color:var(--brainstorm-accent-fg-2);border-radius:5px;border:0;font-family:inherit;font-weight:600;font-size:18px;height:50px;width:110px;cursor:pointer;outline:none}button[data-v-44895b23]:hover{opacity:.9}", ""]);

// exports
